import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export const calmEase = [0.22, 1, 0.36, 1];

const VIEWPORT_ONCE = { once: true, margin: "-60px" };
const REVEAL_VISIBLE = { opacity: 1, y: 0 };
const STAGGER_ITEM_VARIANTS = {
    hidden: { opacity: 0, y: 28 },
    show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: calmEase } },
};

// Fade-up reveal triggered when the element scrolls into view.
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={REVEAL_VISIBLE}
            viewport={VIEWPORT_ONCE}
            transition={{ duration: 0.6, ease: calmEase, delay }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

// Parent that staggers its StaggerItem children as they enter the viewport.
export const Stagger = ({ children, className = "", stagger = 0.1, ...rest }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : "hidden"}
            whileInView="show"
            viewport={VIEWPORT_ONCE}
            variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export const StaggerItem = ({ children, className = "", ...rest }) => (
    <motion.div
        className={className}
        variants={STAGGER_ITEM_VARIANTS}
        {...rest}
    >
        {children}
    </motion.div>
);
